<template>
  <div>
    <span class="uppercase font-medium text-sm text-muted block ml-2 tracking-wide">
      Categories
    </span>
    <nav class="space-y-1 mt-2" aria-label="Sidebar">
      <button
        :class="[
          isCurrent(null) && ['bg-gray-100 text-gray-900'],
          !isCurrent(null) && ['text-gray-600 hover:bg-gray-50 hover:text-gray-900'],
        ]"
        class="flex items-center px-3 py-2 text-sm font-medium rounded-md w-full focus:outline-none"
        @click="setCurrent(null)"
      >
        <span class="truncate"> All </span>
      </button>
      <button
        v-for="productCategory in productCategories"
        :key="productCategory.id"
        :class="[
          isCurrent(productCategory.id) && ['bg-gray-100 text-gray-900'],
          !isCurrent(productCategory.id) && ['text-gray-600 hover:bg-gray-50 hover:text-gray-900'],
        ]"
        class="flex items-center px-3 py-2 text-sm font-medium rounded-md w-full focus:outline-none"
        @click="setCurrent(productCategory.id)"
      >
        <span class="truncate">
          {{ productCategory.name }}
        </span>
      </button>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    currentProductCategoryId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    productCategories() {
      return this.$store.state.ui.productCategories.ids.map(
        (id) => this.$store.state.entities.productCategories.byId[id]
      );
    },
  },
  created() {
    this.fetchProductCategories();
  },
  methods: {
    async fetchProductCategories() {
      try {
        await this.$store.dispatch({
          type: 'ui/productCategories/load',
        });
      } catch (error) {
        //
      }
    },
    isCurrent(productCategoryId) {
      return productCategoryId === this.currentProductCategoryId;
    },
    setCurrent(productCategoryId) {
      if (this.isCurrent(productCategoryId)) {
        return;
      }

      this.$emit('change', productCategoryId);
    },
  },
};
</script>
